import EbisPopover from './EbisPopover';

export default EbisPopover;
